export enum MarketResolutionMode {
  Conviction = 'conviction',
  Timed = 'timed',
}
